import {useCallback, useState} from 'react';

import type {User} from 'src/openapi/admin/models/User';

type AddUserFormState = {
    email: string,
    firstName: string,
    lastName: string,
    roleId: string | undefined,
    vendorId: string | undefined,
    user: User | null,
};

type Return = {
    form: AddUserFormState,
    setField: <K extends keyof AddUserFormState>(field: K, value: AddUserFormState[K]) => void,
    reset: () => void,
    setUser: (user: User | null) => void,
};

const initialState: AddUserFormState = {
    email: '',
    firstName: '',
    lastName: '',
    roleId: undefined,
    vendorId: undefined,
    user: null,
};

export const useAddUserForm = (): Return => {
    const [form, setForm] = useState<AddUserFormState>(initialState);

    const setField = useCallback(<K extends keyof AddUserFormState>(field: K, value: AddUserFormState[K]) => {
        setForm(prev => ({...prev, [field]: value}));
    }, []);

    const reset = useCallback(() => {
        setForm(initialState);
    }, []);

    const setUser = useCallback((user: User | null) => {
        if (user) {
            setForm(prev => ({
                ...prev,
                user,
                email: user.email,
                firstName: user.firstName,
                lastName: user.lastName,
            }));
        } else {
            setForm(prev => ({
                ...prev,
                user: null,
                firstName: '',
                lastName: '',
                roleId: undefined,
                vendorId: undefined,
            }));
        }
    }, []);

    return {form, setField, reset, setUser};
};
